import React from 'react'
import {
  Grid,
  RadioGroup,
  FormControlLabel,
  Button,
  Box,
  Tooltip,
  Checkbox,
} from '@material-ui/core'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Formik, Field } from 'formik'
import LiquidSelectAdapter from '@src/components/LiquidSelectAdapter'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import clsx from 'clsx'
import { configContext } from '../DnaPlates'
import {
  usePlateSessionFieldMutation,
  usePlateSpecificationValidationMutation,
  usePlateTotalValidationMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import { useSpecificationCalculationLazyQuery } from '@src/queries/ConfiguratorTubesQuery.generated'
import ValidationErrors from '../../../validations/ValidationErrors'
import {
  Specifications,
  ActiveLinkTypeDnaplate,
  CountryCodes,
  PlateProduct,
  formatedScaleValues,
} from '../enum'
import { dnaPlatesRoute, useRouter } from '@src/routes'
import CircleLoader from '@src/components/CircleLoader'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import { daughterPlatesOptions } from '@src/routes/Configurators/components/OptionalModifications/ModificationResponse'
import InfoIcon from '@material-ui/icons/Info'
import { TubeProperties } from '../../../utils/enum'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(2, 5, 10, 5),
      marginBottom: theme.spacing(8),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(3, 0),
    },
    label: {
      fontWeight: 'bold',
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(4),
    },
    leftSpace: {
      paddingLeft: theme.spacing(2),
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      verticalAlign: 'middle',
    },
    radio: {
      padding: theme.spacing(1),
    },
    fieldLabel: {
      paddingTop: theme.spacing(6),
      '& label': {
        fontWeight: 'bold',
        fontSize: theme.typography.pxToRem(14),
      },
      '& .MuiInputBase-fullWidth': {
        width: 300,
      },
    },
    minYield: {
      textAlign: 'center',
      fontStyle: 'italic',
    },

    confirmButton: {
      color: theme.palette.common.white,
      width: theme.spacing(50),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: theme.spacing(30),
      width: theme.spacing(60),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    chart: {
      height: theme.spacing(50),
      width: theme.spacing(87.5),
    },
    colorRed: {
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(13),
    },
    hideRow: {
      display: 'none',
    },
    bottomMargin: {
      paddingLeft: theme.spacing(4),
    },
    helpMargin: {
      marginTop: theme.spacing(8),
    },
    textInput: {
      width: theme.spacing(71),
    },
    textInputOthers: {
      width: theme.spacing(30),
      height: theme.spacing(8),
      marginLeft: theme.spacing(8),
    },
    topPadding: {
      alignSelf: 'center',
    },
    InfoPopup: {
      maxWidth: theme.spacing(64),
      backgroundColor: theme.palette.common.white,
      position: 'relative',
      border: `1px solid ${theme.palette.common.white}`,
      boxShadow: '1px 1px 20px 1px lightgrey',
      padding: theme.spacing(5),
      fontSize: theme.typography.pxToRem(12),
      color: '#1b1b25',
      borderRadius: '2%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    arrow1: {
      color: theme.palette.common.white,
    },
    IconButton: {
      outlined: true,
      padding: theme.spacing(0.4, 1, 1, 1),
      marginBottom: theme.spacing(1),
    },
    InfoIcon: {
      position: 'relative',
      fontSize: theme.typography.pxToRem(16),
      top: theme.spacing(0.5),
      marginLeft: theme.spacing(1.5),
    },
    helpText: {
      fontSize: theme.typography.pxToRem(12),
      marginLeft: theme.spacing(4),
      color: '#1b1b25',
    },
    labelFont: {
      paddingLeft: theme.spacing(4),
      '& .MuiTypography-body1': {
        fontSize: 14,
      },
    },
    leftspaceCon: {
      paddingLeft: theme.spacing(4),
    },
    componentSpacing: {
      paddingTop: theme.spacing(8),
    },
    errormsg: {
      marginLeft: theme.spacing(4),
    },
    formateHelpText: {
      marginLeft: theme.spacing(1),
      fontSize: theme.typography.pxToRem(12),
    },
    graphText: {
      marginTop: theme.spacing(1),
      fontSize: theme.typography.pxToRem(13),
    },
    helpIcon: {
      margin: theme.spacing(0, 1, 1, 1),
    },
    radioButtons: {
      width: theme.spacing(43),
    },
    radioYesOrNo: {
      width: theme.spacing(80),
    },
    over1: {
      fontSize: theme.typography.pxToRem(14),
      color: '#1d5293',
      fontWeight: theme.typography.fontWeightMedium,
      paddingLeft: theme.spacing(2),
    },
    overrideCheckBox: {
      padding: theme.spacing(0),
    },
    specificationsHeading: {
      paddingLeft: theme.spacing(3.5),
    },
    specificationsHelpText: {
      fontSize: theme.typography.pxToRem(12),
    },
    concentartionOthers: {
      width: theme.spacing(30),
      height: theme.spacing(8),
    },
    constrainImageToBox: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  }
})

const DnaPlatesSpecifications = (props) => {
  const { specificationsData, productDetails } = props
  const classes = useStyles()
  const { state, dispatch } = React.useContext(configContext)
  const { sessionData, isPageLoad } = state
  const [platesessionField] = usePlateSessionFieldMutation()
  const [
    plateSpecificationValidation,
    { loading: specificationValidationLoading },
  ] = usePlateSpecificationValidationMutation()
  const [getSpecificationCalculation, { data, loading: specificationLoading }] =
    useSpecificationCalculationLazyQuery()
  const [formate, setFormate] = React.useState(sessionData[0].format)
  const [purification, setPurification] = React.useState(
    sessionData[0].purification
  )
  const [normalization, setNormalization] = React.useState(
    sessionData[0].category
  )
  const [scale, setScale] = React.useState(sessionData[0].scale)
  const [concentration, setConcentration] = React.useState(
    sessionData[0].isConcentrationOther
      ? Specifications.PackageTypeOther
      : sessionData[0].concentration
  )
  const [amount, setAmount] = React.useState(sessionData[0].amount)
  const [daughterPlates, setDaughterPlates] = React.useState(
    sessionData[0].daughterPlateCount
  )
  const [daughterPlatesRange, setDaughterPlatesRange] = React.useState(10)
  const [stateToSave, setStateToSave] = React.useState(false)
  const [isAmountValidate, setIsAmountValidate] = React.useState(
    sessionData[0].isAmountSelected
  )
  const [isConcentrationValidate, setIsConcentrationValidate] = React.useState(
    sessionData[0].isConcentrationSelected
  )
  const [maxAmount, setMaxAmount] = React.useState(5)
  const [maxVolume, setMaxVolume] = React.useState(10)
  const [minVolume, setMinVolume] = React.useState(10)
  const [maxConcentration, setMaxConcentration] = React.useState(5)
  const [isOverriden, setIsOverriden] = React.useState(
    sessionData[0].isSpecificationsOverridden
  )
  const [othersValue, setOthersValue] = React.useState(
    sessionData[0].wellList[0].other
  )
  const [concentrationOther, setConcentrationOther] = React.useState(
    sessionData[0].isConcentrationOther ? sessionData[0].concentration : ''
  )
  const [callConcentrationOthersDebounce, setCallConcentrationOthersDebounce] =
    React.useState(false)
  const debouncedConcentrationOthers = useDebounce(
    concentrationOther,
    TubeProperties.SEQUENCE_API_TIME
  )
  const [callConcentrationDebounce, setCallConcentrationDebounce] =
    React.useState(false)
  const [callAmountDebounce, setCallAmountDebounce] = React.useState(false)
  const debouncedConcentration = useDebounce(
    concentration,
    TubeProperties.SEQUENCE_API_TIME
  )
  const debouncedAmount = useDebounce(amount, TubeProperties.SEQUENCE_API_TIME)
  const [callOthersDebounce, setCallOthersDebounce] = React.useState(false)
  const debouncedOthers = useDebounce(
    othersValue,
    TubeProperties.SEQUENCE_API_TIME
  )
  const [validationCall, setValidationCall] = React.useState(true)
  const [calculationCall, setCalculationCall] = React.useState(false)
  const [isConcentrationChanged, setIsConcentrationChanged] =
    React.useState(false)
  const [isAmountChanged, setIsAmountChanged] = React.useState(false)
  const [isVolumeChanged, setIsVolumeChanged] = React.useState(false)
  const [validationJPCon, setValidationJPCon] = React.useState<string[]>([])

  const [reqFormate, setReqFormate] = React.useState(false)
  const [reqpurification, setReqpurification] = React.useState(false)
  const [reqConcentration, setReqConcentration] = React.useState(false)
  const [reqAmount, setReqAmount] = React.useState(false)
  const [reqScale, setReqScale] = React.useState(false)
  const [reqNormalization, setReqNormalization] = React.useState(false)

  const intl = useIntl()
  let [splChar] = React.useState<string>('')
  const checkSpecialChar = (value): string => {
    splChar = ''
    value !== undefined &&
      value.split('').forEach((c) => {
        if (!c.match(/^[0-9.]*$/) && !splChar.includes(c)) {
          if (splChar === '') {
            splChar = c
          } else {
            splChar = splChar + ', ' + c
          }
        }
      })
    return splChar
  }
  let [concentartionsplChar] = React.useState<string>('')
  const checkConcentartionSpecialChar = (value): string => {
    concentartionsplChar = ''
    value !== undefined &&
      value.split('').forEach((c) => {
        if (!c.match(/^[0-9]*$/) && !concentartionsplChar.includes(c)) {
          if (concentartionsplChar === '') {
            concentartionsplChar = c
          } else {
            concentartionsplChar = concentartionsplChar + ', ' + c
          }
        }
      })
    return concentartionsplChar
  }
  React.useEffect(() => {
    if (isPageLoad) {
      setFormate(sessionData[0].format)
      setPurification(sessionData[0].purification)
      setNormalization(sessionData[0].category)
      setScale(sessionData[0].scale)
      setConcentration(
        sessionData[0].isConcentrationOther
          ? Specifications.PackageTypeOther
          : sessionData[0].concentration
      )
      setAmount(sessionData[0].amount)
      setDaughterPlates(sessionData[0].daughterPlateCount)
      setIsAmountValidate(sessionData[0].isAmountSelected)
      setIsConcentrationValidate(sessionData[0].isConcentrationSelected)
      setIsOverriden(sessionData[0].isSpecificationsOverridden)
      setOthersValue(sessionData[0].wellList[0].other)
      setConcentrationOther(
        sessionData[0].isConcentrationOther ? sessionData[0].concentration : ''
      )
      setStateToSave(true)
      if (isOverriden !== true && sessionData[0].wellList[0].pageNo === 3) {
        if (
          sessionData[0].wellList[0].format === '' ||
          !sessionData[0].wellList[0].format
        ) {
          setReqFormate(true)
        }
        if (
          sessionData[0].wellList[0].purification === '' ||
          !sessionData[0].wellList[0].purification
        ) {
          setReqpurification(true)
        }
        if (
          sessionData[0].wellList[0].concentration === ' ' ||
          !sessionData[0].wellList[0].concentration
        ) {
          setReqConcentration(true)
        }
        if (
          sessionData[0].wellList[0].amount === ' ' ||
          !sessionData[0].wellList[0].amount
        ) {
          setReqAmount(true)
        }
        if (
          sessionData[0].wellList[0].scale === ' ' ||
          !sessionData[0].wellList[0].scale
        ) {
          setReqScale(true)
        }
        if (
          sessionData[0].wellList[0].category === ' ' ||
          !sessionData[0].wellList[0].category
        ) {
          setReqNormalization(true)
        }
      }
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPageLoad])

  const specificationCalculation = async (obj) => {
    await getSpecificationCalculation({
      variables: { input: obj, product: productDetails },
    })
  }

  const savePlateDataToSession = async (obj) => {
    await platesessionField({
      variables: { input: obj, productInput: productDetails },
    })
  }

  const validationSpecifications = async (obj) => {
    const response = await plateSpecificationValidation({
      variables: { input: obj, productInput: productDetails },
    })
    const { data } = response
    if (
      data?.plateSpecificationValidation?.response &&
      !data.plateSpecificationValidation.serverError
    ) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({
        type: 'UPDATE_WELLSPECIFICATION_VALIDATION',
        data: data.plateSpecificationValidation.response,
      })
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
  }

  const amountValue = (value) => {
    const index = value.indexOf('.')
    if (index !== -1) {
      value = value.slice(0, index + 2)
    }
    return value
  }

  const scaleGrahphValue = (value) => {
    if (value) {
      const index = value.indexOf('.')
      return index !== -1
    }
    return false
  }

  React.useEffect(() => {
    let intersectionOfScale: string[] =
      state.wellSpecifications.find((well) => well.listScale)?.listScale || []
    let intersectionOfFormat: string[] =
      state.wellSpecifications.find((well) => well.listFormat)?.listFormat || []
    let intersectionOfPurification: string[] =
      state.wellSpecifications.find((well) => well.listPurification)
        ?.listPurification || []

    state.wellSpecifications.forEach((well) => {
      const { listScale = [], listFormat = [], listPurification = [] } = well

      if (listScale)
        intersectionOfScale = intersectionOfScale.filter((scale) =>
          listScale.includes(scale)
        )
      if (listFormat)
        intersectionOfFormat = intersectionOfFormat.filter((format) =>
          listFormat.includes(format)
        )
      if (listPurification)
        intersectionOfPurification = intersectionOfPurification.filter(
          (purification) => listPurification.includes(purification)
        )
    })

    dispatch({
      type: 'UPDATE_INTERSECTION_VALUES',
      data: {
        ...state.intersectionValues,
        listPurification: intersectionOfPurification,
        listScale: intersectionOfScale,
        listFormat: intersectionOfFormat,
      },
    })
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.wellSpecifications])

  const [validationConcentrationErrors, setValidationConcentrationErrors] =
    React.useState<string[]>([])
  const [validationAmountErrors, setValidationAmountErrors] = React.useState<
    string[]
  >([])
  const [validationVolumeErrors, setValidationVolumeErrors] = React.useState<
    string[]
  >([])
  const [validationFixedVolumeWellErrors, setValidationFixedVolumeWellErrors] =
    React.useState<string[]>([])

  const [inValidConcentration, setInValidConcentration] = React.useState<
    string[]
  >([])
  const [invalidAmount, setInvalidAmount] = React.useState<string[]>([])
  const [inValidVolume, setInValidVolume] = React.useState<string[]>([])

  const checkValidation = (value) => {
    const errorvolume: string[] = []
    setInValidVolume([])
    const errorAmount: string[] = []
    setInvalidAmount([])
    const errorconcentration: string[] = []
    setInValidConcentration([])
    if (amount !== '' && Number(amount) < 1) {
      errorAmount.push(intl.formatMessage(messages.CONF_DNAPLATES_ERROR_AMOUNT))
    }
    if (value.errorValues.length !== null) {
      value.errorValues.forEach((obj) => {
        if (obj !== null) {
          if (obj.key === Specifications.concentration) {
            errorconcentration.push(
              intl.formatMessage(messages.CONF_DNAPLATES_ERROR_CONCENTRATION)
            )
          }
          if (obj.key === Specifications.amount) {
            if (
              obj.validationType === Specifications.amount &&
              errorAmount.length === 0
            ) {
              errorAmount.push(
                intl.formatMessage(messages.CONF_DNAPLATES_ERROR_AMOUNT)
              )
            } else if (obj.validationType === Specifications.volume) {
              errorvolume.push(
                intl.formatMessage(messages.CONF_DNAPLATES_ERROR_VOLUME)
              )
            }
          }
        }
      })
    }
    setInValidConcentration(errorconcentration)
    setInvalidAmount(errorAmount)
    setInValidVolume(errorvolume)
  }

  React.useEffect(() => {
    if (
      state.specificationCalculationResponse.calculatedValues.maxAmount >= 5
    ) {
      setMaxAmount(
        state.specificationCalculationResponse.calculatedValues.maxAmount
      )
    }

    if (state.specificationCalculationResponse.calculatedValues.maxVolume) {
      setMaxVolume(
        state.specificationCalculationResponse.calculatedValues.maxVolume
      )
    }

    if (
      state.specificationCalculationResponse.calculatedValues
        .maxConcentration >= 5
    ) {
      setMaxConcentration(
        state.specificationCalculationResponse.calculatedValues.maxConcentration
      )
    }
    if (
      state.specificationCalculationResponse.calculatedValues.minVolume &&
      state.specificationCalculationResponse.calculatedValues.minVolume > 0
    ) {
      setMinVolume(
        state.specificationCalculationResponse.calculatedValues.minVolume
      )
    } else {
      setMinVolume(10)
    }
    if (
      state.specificationCalculationResponse.calculatedValues
        .daughterPlateRange >= 0
    ) {
      setDaughterPlatesRange(
        state.specificationCalculationResponse.calculatedValues
          .daughterPlateRange
      )
    }
    if (
      state.specificationCalculationResponse.calculatedValues
        .daughterPlateRange !== null &&
      state.specificationCalculationResponse.calculatedValues
        .daughterPlateRange !== -1 &&
      state.specificationCalculationResponse.calculatedValues
        .daughterPlateRange < Number(daughterPlates)
    ) {
      setDaughterPlates(Specifications.daughterPlatesValue)
      sessionData.forEach((data) => {
        data.daughterPlateCount = Specifications.daughterPlatesValue
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      savePlateDataToSession(sessionData)
    }
    if (
      state.specificationCalculationResponse.calculatedValues.scale !== null &&
      state.specificationCalculationResponse.calculatedValues.scale !== ''
    ) {
      let scaleresp =
        state.specificationCalculationResponse.calculatedValues.scale
      scaleresp =
        Number(scaleresp).toFixed(4) + formatedScaleValues.SCALE_4digit
      setScale(scaleresp)
      sessionData.forEach((data) => {
        data.scale = scaleresp
        data.wellList.forEach((well) => {
          well.scale = scaleresp
        })
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
    }
    if (
      state.specificationCalculationResponse.calculatedValues.amount !== null &&
      state.specificationCalculationResponse.calculatedValues.amount !== ''
    ) {
      setAmount(
        amountValue(
          state.specificationCalculationResponse.calculatedValues.amount
        )
      )
      sessionData.forEach((data) => {
        data.amount = amountValue(
          state.specificationCalculationResponse.calculatedValues.amount
        )
        data.wellList.forEach((well) => {
          well.amount = amountValue(
            state.specificationCalculationResponse.calculatedValues.amount
          )
        })
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.specificationCalculationResponse])

  React.useEffect(() => {
    if (data !== undefined) {
      if (data.getSpecificationCalculation) {
        dispatch({
          type: 'UPDATE_SPECIFICATION_CALCULATION_RESPONSE',
          data: data.getSpecificationCalculation,
        })
      }
      checkValidation(data.getSpecificationCalculation)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const deselectInvalidOption = (intersectionValues) => {
    let callDispatcher = 0
    if (
      intersectionValues.listScale &&
      intersectionValues.listScale.length !== 0 &&
      sessionData[0].scale !== '' &&
      !intersectionValues.listScale.includes(sessionData[0].scale)
    ) {
      sessionData.forEach((data) => {
        data.scale = ''
        data.wellList.forEach((well) => {
          well.scale = ''
        })
      })
      setScale('')
      callDispatcher = callDispatcher + 1
    }
    if (
      intersectionValues.listFormat &&
      intersectionValues.listFormat.length !== 0 &&
      sessionData[0].format !== '' &&
      !intersectionValues.listFormat.includes(sessionData[0].format)
    ) {
      sessionData.forEach((data) => {
        data.format = ''
        data.wellList.forEach((well) => {
          well.format = ''
        })
      })
      setFormate('')
      callDispatcher = callDispatcher + 1
    }
    if (
      intersectionValues.listPurification &&
      intersectionValues.listPurification.length !== 0 &&
      sessionData[0].purification !== '' &&
      !intersectionValues.listPurification.includes(sessionData[0].purification)
    ) {
      sessionData.forEach((data) => {
        data.purification = ''
        data.wellList.forEach((well) => {
          well.purification = ''
        })
      })
      setPurification('')
      callDispatcher = callDispatcher + 1
    }
    if (callDispatcher !== 0) {
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
    }
  }

  const autoSelectValidOption = (intersectionValues) => {
    let callSession = 0
    if (
      intersectionValues.listScale.length === 1 ||
      intersectionValues.listFormat.length === 1 ||
      intersectionValues.listPurification.length === 1
    ) {
      if (
        intersectionValues.listScale.length === 1 &&
        sessionData[0].scale !== intersectionValues.listScale[0]
      ) {
        sessionData.forEach((data) => {
          data.scale = intersectionValues.listScale[0]
          data.wellList.forEach((well) => {
            well.scale = intersectionValues.listScale[0]
          })
        })
        setScale(intersectionValues.listScale[0])
        setReqScale(false)
        callSession = callSession + 1
      }
      if (
        intersectionValues.listFormat.length === 1 &&
        sessionData[0].format !== intersectionValues.listFormat[0]
      ) {
        sessionData.forEach((data) => {
          data.format = intersectionValues.listFormat[0]
          data.wellList.forEach((well) => {
            well.format = intersectionValues.listFormat[0]
          })
        })
        setFormate(intersectionValues.listFormat[0])
        if (intersectionValues.listFormat[0] !== Specifications.Other) {
          setOthersValue('')
        }
        setReqFormate(false)
        callSession = callSession + 1
      }
      if (
        intersectionValues.listPurification.length === 1 &&
        sessionData[0].purification !== intersectionValues.listPurification[0]
      ) {
        sessionData.forEach((data) => {
          data.purification = intersectionValues.listPurification[0]
          data.wellList.forEach((well) => {
            well.purification = intersectionValues.listPurification[0]
          })
        })
        setPurification(intersectionValues.listPurification[0])
        setReqpurification(false)
        callSession = callSession + 1
      }
      if (
        Array.isArray(intersectionValues.listFormat) &&
        intersectionValues.listFormat.length === 2 &&
        intersectionValues.listFormat.includes(Specifications.Other) &&
        sessionData[0].format !== Specifications.Other
      ) {
        sessionData.forEach((data) => {
          data.format = intersectionValues.listFormat[0]
          data.wellList.forEach((well) => {
            well.format = intersectionValues.listFormat[0]
          })
        })
        setFormate(intersectionValues.listFormat[0])
        setReqFormate(false)
        callSession = callSession + 1
      }
      if (callSession !== 0) {
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...state.sessionData],
        })
      }
    }
  }

  React.useEffect(() => {
    dispatch({
      type: 'UPDATE_SPECIFICATION_CALCULATION_INPUT',
      data: {
        ...state.specificationCalculationInput,
        listScaleFromRules: state.intersectionValues.listScale,
      },
    })

    if (!isOverriden) {
      autoSelectValidOption(state.intersectionValues)
      deselectInvalidOption(state.intersectionValues)
    }

    if (formate !== null && formate !== undefined && formate.length > 0) {
      specificationCalculation({
        ...state.specificationCalculationInput,
        listScaleFromRules: state.intersectionValues.listScale,
      })
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.intersectionValues])

  const disablingRadioButton = (data, categoryName) => {
    if (Object.keys(state.intersectionValues).length !== 0) {
      let list: any = []

      switch (categoryName) {
        case messages.CONF_SCALE_TEXT.defaultMessage: {
          list = state.intersectionValues.listScale

          break
        }
        case messages.CONF_FORMAT_TEXT.defaultMessage: {
          list = state.intersectionValues.listFormat

          break
        }
        case messages.CONF_PURIFICATION_TEXT.defaultMessage: {
          list = state.intersectionValues.listPurification

          break
        }
        default:
          return false
      }
      if (!list) {
        return true
      } else if (list.includes(data.value)) {
        return false
      }
    }
    return true
  }

  React.useEffect(() => {
    if (!validationCall && calculationCall) {
      specificationCalculation(state.specificationCalculationInput)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.specificationCalculationInput])

  React.useEffect(() => {
    if (stateToSave) {
      let calculatedWell: any
      let wellBaseCount = 0
      sessionData.forEach((data) => {
        data.daughterPlateCount = daughterPlates
        data.format = formate
        data.purification = purification
        data.scale = scale
        if (validationConcentrationErrors.length === 0) {
          if (
            productDetails.countryCode === CountryCodes.JP &&
            concentration === Specifications.PackageTypeOther
          ) {
            if (validationJPCon.length === 0) {
              data.concentration = concentrationOther.trim()
            }
            data.isConcentrationOther = true
          } else {
            data.concentration = concentration
            data.isConcentrationOther = false
          }
        }
        if (
          validationAmountErrors.length === 0 &&
          validationVolumeErrors.length === 0
        ) {
          data.amount = amount
        }
        if (data.plateType === Specifications.MIXED) {
          data.category = Specifications.Yes
        } else if (
          (productDetails.countryCode === CountryCodes.JP &&
            data.plateType === Specifications.STANDARD &&
            data.wellType === PlateProduct.wellType96) ||
          (productDetails.countryCode === CountryCodes.IN &&
            data.plateType === Specifications.STANDARD)
        ) {
          data.category = Specifications.No
        } else if (data.wellType === PlateProduct.wellType) {
          data.category = Specifications.Yes
        } else {
          data.category = normalization
        }
        data.isAmountSelected = isAmountValidate
        data.isConcentrationSelected = isConcentrationValidate
        data.isSpecificationsOverridden = isOverriden
        data.wellList.forEach((well) => {
          well.format = formate
          well.other = othersValue
          well.purification = purification
          well.scale = scale
          if (validationConcentrationErrors.length === 0) {
            if (
              productDetails.countryCode === CountryCodes.JP &&
              concentration === Specifications.PackageTypeOther
            ) {
              if (validationJPCon.length === 0) {
                well.concentration = concentrationOther.trim()
              }
            } else {
              well.concentration = concentration
            }
          }
          if (
            validationAmountErrors.length === 0 &&
            validationVolumeErrors.length === 0
          ) {
            well.amount = amount
          }
          well.listError = []
          if (data.plateType === Specifications.MIXED) {
            well.category = Specifications.Yes
          } else if (
            (productDetails.countryCode === CountryCodes.JP &&
              data.plateType === Specifications.STANDARD &&
              data.wellType === PlateProduct.wellType96) ||
            (productDetails.countryCode === CountryCodes.IN &&
              data.plateType === Specifications.STANDARD)
          ) {
            well.category = Specifications.No
          } else if (data.wellType === PlateProduct.wellType) {
            well.category = Specifications.Yes
          } else {
            well.category = normalization
          }
          if (well.baseCount > wellBaseCount) {
            calculatedWell = well
            wellBaseCount = well.baseCount
          }
        })
      })
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      dispatch({
        type: 'UPDATE_SPECIFICATION_CALCULATION_INPUT',
        data: {
          ...state.specificationCalculationInput,
          format: formate,
          purification: purification,
          concentration:
            productDetails.countryCode === CountryCodes.JP &&
            concentration === Specifications.PackageTypeOther
              ? validationJPCon.length === 0
                ? concentrationOther.trim()
                : ''
              : concentration,
          scale: scale,
          amount: amount,
          fiveMod: calculatedWell?.fiveMod,
          threeMod: calculatedWell?.threeMod,
          sequence: calculatedWell?.sequence,
          category:
            sessionData[0].plateType === Specifications.MIXED
              ? Specifications.Yes
              : (productDetails.countryCode === CountryCodes.JP &&
                    sessionData[0].plateType === Specifications.STANDARD &&
                    sessionData[0].wellType === PlateProduct.wellType96) ||
                  (productDetails.countryCode === CountryCodes.IN &&
                    sessionData[0].plateType === Specifications.STANDARD)
                ? Specifications.No
                : sessionData[0].wellType === PlateProduct.wellType
                  ? Specifications.Yes
                  : normalization,
          plateType: sessionData[0].plateType,
          daughterPlateNumber: daughterPlates,
          wellType: sessionData[0].wellType,
          isamountValidate: isAmountValidate,
          isConcentrationValidate: isConcentrationValidate,
          isOverriden: isOverriden,
          isConcentrationChanged: isConcentrationChanged,
          isAmountChanged: isAmountChanged,
          isVolumeChanged: isVolumeChanged,
          maxAmount: maxAmount,
          maxVolume: maxVolume,
          maxConcentration: maxConcentration,
        },
      })
      if (
        validationAmountErrors.length === 0 &&
        validationVolumeErrors.length === 0 &&
        validationConcentrationErrors.length === 0
      ) {
        savePlateDataToSession(sessionData)
        if (validationCall) {
          const wellList = sessionData.map((single) => single.wellList).flat()
          validationSpecifications(wellList)
        }
      }
      setStateToSave(false)
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateToSave])

  const [plateTotalValidation, { loading: totalValidationLoading }] =
    usePlateTotalValidationMutation()

  const router = useRouter()
  const checkRequiredFields = (error) => {
    error.forEach((obj) => {
      if (
        obj.key === Specifications.format ||
        (sessionData[0].format === Specifications.Other &&
          sessionData[0].wellList[0].other.length === 0 &&
          isOverriden === false)
      ) {
        setReqFormate(true)
      }
      if (obj.key === Specifications.purification) {
        setReqpurification(true)
      }
      if (
        obj.key === Specifications.concentration &&
        !(sessionData[0].isConcentrationOther && validationJPCon.length !== 0)
      ) {
        setReqConcentration(true)
      }
      if (obj.key === Specifications.amount) {
        setReqAmount(true)
      }
      if (obj.key === Specifications.scale) {
        setReqScale(true)
      }
      if (obj.key === Specifications.category) {
        setReqNormalization(true)
      }
    })
  }

  const totalValidation = async () => {
    const response: any = await plateTotalValidation({
      variables: { input: sessionData, productInput: productDetails },
    })

    const { data } = response
    let errorCount = 0
    if (data && !data.plateTotalValidation.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({
        type: 'UPDATE_TOTALVALIDATION',
        data: data.plateTotalValidation.response,
      })
      data.plateTotalValidation.response.forEach((plate) => {
        plate.wellList.forEach((well) => {
          if (well.listError.length !== 0) {
            errorCount = errorCount + 1
          }
        })
      })
      if (
        (sessionData[0].format === Specifications.Other &&
          sessionData[0].wellList[0].other.length === 0 &&
          isOverriden === false) ||
        (sessionData[0].isConcentrationOther && validationJPCon.length !== 0)
      ) {
        errorCount = errorCount + 1
      }
      if (errorCount !== 0) {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        checkRequiredFields(
          data.plateTotalValidation.response[0].wellList[0].listError
        )
        window.scrollTo(0, 0)
        sessionData.forEach((data) => {
          data.pageNo = 2
        })
        dispatch({ type: 'SET_STEP_NO', data: 2 })
      } else {
        dispatch({ type: 'SET_STEP_NO', data: 3 })
        const url = `${dnaPlatesRoute.index()}?product=${
          productDetails.productType
        }&activeLink=${ActiveLinkTypeDnaplate.PackingAndShipping}`
        router.push(url)
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: '',
        })
      }
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
    savePlateDataToSession(sessionData)
  }
  const goToNextStep3 = () => {
    if (normalization === '') {
      validationFixedVolumeWellErrors.length = 0
      validationFixedVolumeWellErrors.push(Specifications.RequiredField)
    }
    if (
      validationAmountErrors.length === 0 &&
      validationVolumeErrors.length === 0 &&
      validationConcentrationErrors.length === 0 &&
      inValidConcentration.length === 0 &&
      invalidAmount.length === 0 &&
      inValidVolume.length === 0
    ) {
      sessionData.forEach((data) => {
        data.pageNo = 3
        delete data.__typename
        data.wellList.forEach((well) => {
          if (data.isSpecificationsOverridden !== true) {
            well.pageNo = 3
          } else {
            well.pageNo = 0
          }
          delete well.__typename
          well.listError.forEach((error) => {
            delete error.__typename
          })
        })
      })
      if (!sessionData[0].isConcentrationOther) {
        setConcentrationOther('')
        setValidationJPCon([])
      }
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      totalValidation()
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
      })
      window.scrollTo(0, 0)
    }
  }

  const handleOverride = (value) => {
    sessionData.forEach((data) => {
      data.pageNo = 2
    })
    dispatch({ type: 'SET_STEP_NO', data: 2 })
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
    setReqFormate(false)
    setReqNormalization(false)
    setReqpurification(false)
    setReqConcentration(false)
    setReqAmount(false)
    setReqScale(false)
    setIsOverriden(value)
    setStateToSave(true)
    setValidationCall(true)
  }

  React.useEffect(
    () => {
      if (
        callConcentrationDebounce &&
        validationConcentrationErrors.length === 0
      ) {
        setCallConcentrationDebounce(false)
        setStateToSave(true)
      }
    },
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedConcentration]
  )

  React.useEffect(
    () => {
      if (
        callAmountDebounce &&
        validationAmountErrors.length === 0 &&
        validationVolumeErrors.length === 0
      ) {
        setCallAmountDebounce(false)
        setStateToSave(true)
      }
    },
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedAmount]
  )

  React.useEffect(
    () => {
      if (callOthersDebounce) {
        setCallOthersDebounce(false)
        if (sessionData[0].format === Specifications.Other) {
          sessionData.forEach((data) => {
            data.wellList.forEach((well) => {
              well.other = debouncedOthers
            })
          })
          dispatch({
            type: 'UPDATE_INPUT',
            data: [...state.sessionData],
          })
          savePlateDataToSession(sessionData)
        }
      }
    },
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedOthers]
  )
  React.useEffect(
    () => {
      if (callConcentrationOthersDebounce) {
        setCallConcentrationOthersDebounce(false)
        if (sessionData[0].isConcentrationOther) {
          setValidationCall(false)
          setIsConcentrationChanged(true)
          setCalculationCall(true)
          setStateToSave(true)
        }
      }
    },
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedConcentrationOthers]
  )

  const handlerChange = (e, type) => {
    sessionData.forEach((data) => {
      data.pageNo = 2
    })
    dispatch({ type: 'SET_STEP_NO', data: 2 })
    dispatch({
      type: 'SET_PAGE_ERROR',
      data: '',
    })
    if (type === Specifications.format) {
      setFormate(e.target.value)
      if (e.target.value !== Specifications.Other) {
        setOthersValue('')
      }
      setReqFormate(false)
      setPurification('')
      setScale('')
      setConcentration('')
      setConcentrationOther('')
      setValidationConcentrationErrors([])
      setValidationJPCon([])
      setInValidConcentration([])
      setValidationVolumeErrors([])
      setInValidVolume([])
      setValidationAmountErrors([])
      setInvalidAmount([])
      setAmount('')
      setDaughterPlates(Specifications.daughterPlatesValue)
      setNormalization('')
      setIsConcentrationValidate(false)
      setIsAmountValidate(false)
      setReqScale(false)
      setReqConcentration(false)
      setReqAmount(false)
      setStateToSave(true)
      setValidationCall(false)
      setCalculationCall(false)
    } else if (type === Specifications.purification) {
      setPurification(e.target.value)
      setReqpurification(false)
      setReqScale(false)
      setReqConcentration(false)
      setReqAmount(false)
      setScale('')
      setConcentration('')
      setConcentrationOther('')
      setValidationConcentrationErrors([])
      setValidationJPCon([])
      setInValidConcentration([])
      setValidationVolumeErrors([])
      setInValidVolume([])
      setValidationAmountErrors([])
      setInvalidAmount([])
      setAmount('')
      setDaughterPlates(Specifications.daughterPlatesValue)
      setNormalization('')
      setIsConcentrationValidate(false)
      setIsAmountValidate(false)
      setStateToSave(true)
      setValidationCall(true)
    } else if (type === Specifications.scale) {
      setScale(e.target.value)
      setReqScale(false)
      setReqAmount(false)
      setAmount('')
      setValidationVolumeErrors([])
      setInValidVolume([])
      setValidationAmountErrors([])
      setInvalidAmount([])
      setDaughterPlates(Specifications.daughterPlatesValue)
      setIsAmountValidate(false)
      setStateToSave(true)
      setValidationCall(false)
      setCalculationCall(true)
    } else if (type === Specifications.concentration) {
      setCalculationCall(false)
      if (e.target.value.length === amountValue(e.target.value).length) {
        let val = ''
        setInValidConcentration([])
        setValidationCall(true)
        setConcentration(amountValue(e.target.value))
        const errconcentration: string[] = []
        if (productDetails.countryCode !== CountryCodes.JP) {
          val = checkSpecialChar(e.target.value)
        } else {
          if (e.target.value !== Specifications.PackageTypeOther) {
            setConcentrationOther('')
            setValidationJPCon([])
          }
        }
        if (
          (val !== null && val !== '' && val.length !== 0) ||
          e.target.value.endsWith('.')
        ) {
          errconcentration.push(
            intl.formatMessage(messages.CONF_DNAPLATES_ERROR_CONCENTRATION)
          )
          setValidationConcentrationErrors(errconcentration)
          setCallConcentrationDebounce(false)
        } else {
          setValidationConcentrationErrors([])
          setReqConcentration(false)
          setReqScale(false)
          setReqAmount(false)
          setIsConcentrationValidate(true)
          setIsConcentrationChanged(true)
          setIsAmountChanged(false)
          setIsVolumeChanged(false)
          setCallConcentrationDebounce(true)
        }
      }
    } else if (type === Specifications.amount) {
      setValidationCall(false)
      setCalculationCall(true)
      if (e.target.value.length === amountValue(e.target.value).length) {
        setInvalidAmount([])
        setAmount(amountValue(e.target.value))
        const erramount: string[] = []
        const val = checkSpecialChar(e.target.value)
        if (
          (val !== null && val !== '' && val.length !== 0) ||
          e.target.value.endsWith('.')
        ) {
          erramount.push(
            intl.formatMessage(messages.CONF_DNAPLATES_ERROR_AMOUNT)
          )
          setValidationAmountErrors(erramount)
          setCallAmountDebounce(false)
        } else {
          setValidationAmountErrors([])
          setReqAmount(false)
          setReqScale(false)
          setScale('')
          setIsConcentrationChanged(false)
          setIsAmountChanged(true)
          setIsVolumeChanged(false)
          setIsAmountValidate(true)
          setCallAmountDebounce(true)
        }
      }
    } else if (type === Specifications.volume) {
      setValidationCall(false)
      setCalculationCall(true)
      if (e.target.value.length === amountValue(e.target.value).length) {
        setInValidVolume([])
        setAmount(amountValue(e.target.value))
        const errvolume: string[] = []
        const val = checkSpecialChar(e.target.value)
        if (
          (val !== null && val !== '' && val.length !== 0) ||
          e.target.value.endsWith('.')
        ) {
          errvolume.push(
            intl.formatMessage(messages.CONF_DNAPLATES_ERROR_VOLUME)
          )
          setValidationVolumeErrors(errvolume)
          setCallAmountDebounce(false)
        } else {
          setValidationVolumeErrors([])
          setReqAmount(false)
          setReqScale(false)
          setScale('')
          setIsConcentrationChanged(false)
          setIsAmountChanged(false)
          setIsVolumeChanged(true)
          setIsAmountValidate(true)
          setCallAmountDebounce(true)
        }
      }
    } else if (type === Specifications.normalization) {
      setValidationFixedVolumeWellErrors([])
      setNormalization(e.target.value)
      setDaughterPlates(Specifications.daughterPlatesValue)
      setReqNormalization(false)
      if (
        e.target.value === 'No' &&
        state.intersectionValues.listScale.length === 1
      ) {
        setScale(state.intersectionValues.listScale[0])
      } else {
        setScale('')
      }
      setAmount('')
      setValidationVolumeErrors([])
      setInValidVolume([])
      setValidationAmountErrors([])
      setInvalidAmount([])
      setStateToSave(true)
      setValidationCall(false)
      setCalculationCall(true)
    } else if (type === Specifications.daughterPlates) {
      setDaughterPlates(e.target.value)
      setStateToSave(true)
      setValidationCall(false)
      setCalculationCall(true)
    } else if (type === Specifications.Other) {
      setOthersValue(e.target.value)
      if (formate.length !== 0) {
        setReqFormate(false)
      }
      setCallOthersDebounce(true)
    } else if (type === Specifications.concentartionOther) {
      setConcentrationOther(e.target.value)
      if (concentration.length !== 0) {
        setReqConcentration(false)
      }
      const errConc: string[] = []
      const val = checkConcentartionSpecialChar(e.target.value)
      if (val !== null && val !== '' && val.length !== 0) {
        errConc.push(
          intl.formatMessage(messages.CONF_DNAPLATE_CONCENTRATION_ERROR_MESSAGE)
        )
        setValidationJPCon(errConc)
        setCallConcentrationOthersDebounce(false)
      } else {
        setValidationJPCon([])
        setCallConcentrationOthersDebounce(true)
      }
    }
  }
  const specificationData = (specificationsData, specificationType) => {
    return specificationsData.specificationModifications.map(
      (specification, index) => {
        return specificationType === Specifications.concentration &&
          specification.value === Specifications.PackageTypeOther ? (
          <Grid container>
            <Grid item sm={2} xs={2}>
              <FormControlLabel
                key={index}
                value={specification.value}
                control={
                  <StyledRadio
                    isConfiguratorsRedesign="true"
                    className={classes.radio}
                    onChange={(e) => handlerChange(e, specificationType)}
                  />
                }
                className={clsx(classes.labelFont, classes.radioButtons)}
                label={
                  messages[specification.displayName]?.defaultMessage ||
                  specification.displayName
                }
                disabled={
                  isOverriden === true
                    ? false
                    : disablingRadioButton(specification, specificationType)
                }
              />
            </Grid>
            <Grid item sm={10} xs={10}>
              <Field
                name="concentrationothers"
                component={LiquidInputAdapter}
                value={concentrationOther}
                onChange={(e) => {
                  handlerChange(e, Specifications.concentartionOther)
                }}
                filled
                autoComplete="off"
                className={classes.concentartionOthers}
                disabled={
                  isOverriden === true
                    ? false
                    : disablingRadioButton(specification, specificationType)
                }
              />
              <ValidationErrors errors={validationJPCon} />
            </Grid>
          </Grid>
        ) : (
          <FormControlLabel
            key={index}
            value={specification.value}
            control={
              <StyledRadio
                isConfiguratorsRedesign="true"
                className={classes.radio}
                onChange={(e) => handlerChange(e, specificationType)}
              />
            }
            className={clsx(classes.labelFont, classes.radioButtons)}
            label={
              messages[specification.displayName]?.defaultMessage ||
              specification.displayName
            }
            disabled={
              isOverriden === true
                ? false
                : disablingRadioButton(specification, specificationType)
            }
          />
        )
      }
    )
  }

  const populateSpecification = (specificationsData, specificationType) => {
    return specificationsData.specifications.map((specificationList, index) => {
      if (specificationList.categoryName === specificationType) {
        return (
          <RadioGroup
            aria-label="radio"
            name="radio"
            value={
              specificationType === Specifications.concentration &&
              productDetails.countryCode === CountryCodes.JP
                ? concentration
                : sessionData[0][specificationType]
            }
            key={index}
          >
            {specificationData(specificationList, specificationType)}
            {specificationType === Specifications.format &&
            (productDetails.isCSRSupervisor || productDetails.isCSR) ? (
              <Grid container>
                <Grid item sm={2} xs={2}>
                  <FormControlLabel
                    value="Other"
                    control={
                      <StyledRadio
                        isConfiguratorsRedesign="true"
                        className={classes.radio}
                        onChange={(e) => handlerChange(e, specificationType)}
                      />
                    }
                    className={clsx(classes.labelFont, classes.radioButtons)}
                    label={intl.formatMessage(messages.CONF_DNAPLATE_OTHER)}
                    disabled={
                      isOverriden === true
                        ? false
                        : disablingRadioButton(
                            { value: 'Other' },
                            specificationType
                          )
                    }
                  />
                </Grid>
                <Grid item sm={10} xs={10}>
                  <Field
                    name="othersValue"
                    component={LiquidInputAdapter}
                    value={othersValue}
                    onChange={(e) => {
                      handlerChange(e, Specifications.Other)
                    }}
                    filled
                    autoComplete="off"
                    className={classes.textInputOthers}
                    disabled={
                      isOverriden === true
                        ? false
                        : disablingRadioButton(
                            { value: 'Other' },
                            specificationType
                          )
                    }
                  />
                </Grid>
              </Grid>
            ) : (
              ''
            )}
          </RadioGroup>
        )
      }
      return null
    })
  }

  const daughterPlatesComponent = () => {
    return (
      <Grid className={clsx(classes.fieldLabel, classes.helpMargin)}>
        <div className={classes.label}>
          <FormattedMessage {...messages.CONF_DAUGHTER_PLATES_DNA_PLATES} />
          <Tooltip
            title={
              <FormattedMessage
                {...messages.CONF_DNAPLATE_PLATE_COPIES_HELPTEXT}
              />
            }
            placement="bottom-end"
            classes={{ tooltip: classes.InfoPopup, arrow: classes.arrow1 }}
            arrow
          >
            <InfoIcon
              aria-label="info"
              color="primary"
              className={classes.InfoIcon}
            ></InfoIcon>
          </Tooltip>
        </div>
        <Field
          name="daughterPlates"
          component={LiquidSelectAdapter}
          options={[...daughterPlatesOptions(daughterPlatesRange)]}
          filled
          value={sessionData[0].daughterPlateCount}
          onChange={(e) => handlerChange(e, Specifications.daughterPlates)}
          className={classes.labelFont}
        />
      </Grid>
    )
  }
  const AmountGraphComponent = (scale) => {
    let scaleGrahph = scale
    if (scale.length === 3) {
      scaleGrahph += '00'
      scaleGrahph += messages.CONF_DNAPLATES_SCALE_PNG.defaultMessage
    } else if (scale.length > 5) {
      scaleGrahph = scale.substring(0, 5)
      scaleGrahph += messages.CONF_DNAPLATES_SCALE_PNG.defaultMessage
    } else if (scale.length === 4) {
      scaleGrahph += '0'
      scaleGrahph += messages.CONF_DNAPLATES_SCALE_PNG.defaultMessage
    } else if (scale.length === 1) {
      scaleGrahph += '.000'
      scaleGrahph += messages.CONF_DNAPLATES_SCALE_PNG.defaultMessage
    } else {
      scaleGrahph += messages.CONF_DNAPLATES_SCALE_PNG.defaultMessage
    }
    return (
      <Grid container className={classes.componentSpacing}>
        <Grid item sm={4} className={classes.leftSpace}>
          <Box display="flex" component="a" className={classes.leftspaceCon}>
            <Box>
              <img
                className={classes.constrainImageToBox}
                alt="scale"
                src={`/static/${scaleGrahph}`}
              />
            </Box>
          </Box>
        </Grid>
        <Grid item sm={6} className={clsx(classes.topPadding)}>
          <div>
            <span>
              <strong>
                <FormattedMessage
                  {...messages.CONF_DNAPLATES_SYNTHESIS_SCALE}
                />
              </strong>
              {scale}
              <FormattedMessage {...messages.CONF_DNAPLATES_SCALE_MEASURE} />
            </span>
          </div>
        </Grid>
      </Grid>
    )
  }
  const ScaleGraphComponent = (scale) => {
    let scaleGrahph = scale.substring(0, 5)
    scaleGrahph += messages.CONF_DNAPLATES_SCALE_PNG.defaultMessage
    return (
      <Grid container className={classes.componentSpacing}>
        <Grid item sm={4} className={classes.leftSpace}>
          <Box display="flex" component="a" className={classes.leftspaceCon}>
            <Box>
              <img
                className={classes.constrainImageToBox}
                alt="scale"
                src={`/static/${scaleGrahph}`}
              />
            </Box>
          </Box>
        </Grid>
        <Grid item sm={6} className={clsx(classes.topPadding)}>
          <div>
            <span>
              <strong>
                {state.specificationCalculationResponse.calculatedValues
                  .maxAmount !== null ? (
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_MINIMUM_AMOUNT_PER_WELL}
                  />
                ) : state.specificationCalculationResponse.calculatedValues
                    .maxVolume !== null ? (
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_MINIMUM_VOLUME_PER_WELL}
                  />
                ) : (
                  ''
                )}
              </strong>
              {state.specificationCalculationResponse.calculatedValues
                .maxAmount !== null
                ? scaleGrahphValue(
                    state.specificationCalculationResponse.calculatedValues
                      .amount
                  )
                  ? parseFloat(
                      state.specificationCalculationResponse.calculatedValues
                        .amount
                    ).toFixed(1)
                  : state.specificationCalculationResponse.calculatedValues
                      .amount
                : state.specificationCalculationResponse.calculatedValues
                      .maxVolume !== null
                  ? scaleGrahphValue(
                      state.specificationCalculationResponse.calculatedValues
                        .amount
                    )
                    ? parseFloat(
                        state.specificationCalculationResponse.calculatedValues
                          .amount
                      ).toFixed(1)
                    : state.specificationCalculationResponse.calculatedValues
                        .amount
                  : ''}
              {state.specificationCalculationResponse.calculatedValues
                .maxAmount !== null ? (
                <FormattedMessage {...messages.CONF_DNAPLATES_AMOUNT_MOLES} />
              ) : state.specificationCalculationResponse.calculatedValues
                  .maxVolume !== null ? (
                <FormattedMessage {...messages.CONF_DNAPLATES_VOLUME_MEASURE} />
              ) : (
                ''
              )}
            </span>
          </div>
          <div className={classes.graphText}>
            {state.specificationCalculationResponse.calculatedValues
              .maxAmount !== null ? (
              <FormattedMessage {...messages.CONF_DNAPLATES_AMOUNT_PER_WELL} />
            ) : state.specificationCalculationResponse.calculatedValues
                .maxVolume !== null ? (
              <FormattedMessage {...messages.CONF_DNAPLATES_VOLUME_PER_WELL} />
            ) : (
              ''
            )}
          </div>
        </Grid>
      </Grid>
    )
  }
  const ScaleComponent = () => {
    return (
      <>
        <Grid className={classes.componentSpacing}>
          <div className={classes.label}>
            <FormattedMessage {...messages.CONF_EXPECTED_YIELDS_POPUP_SCALE} />
          </div>
          <div className={classes.leftSpace}>
            {populateSpecification(specificationsData, Specifications.scale)}
          </div>
          {state.intersectionValues.listScale &&
          state.intersectionValues.listScale.length === 0 &&
          !isOverriden ? (
            <div className={classes.errormsg}>
              <ValidationErrors
                errors={[
                  intl.formatMessage(
                    messages.CONF_DNAPLATE_SCALE_ERROR_MESSAGE
                  ),
                ]}
              />
            </div>
          ) : (
            <Grid className={reqScale ? '' : classes.hideRow}>
              <div className={clsx(classes.colorRed, classes.errormsg)}>
                <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
              </div>
            </Grid>
          )}
        </Grid>
        {scale === '' ||
        scale === null ||
        validationConcentrationErrors.length !== 0 ||
        inValidConcentration.length !== 0 ||
        (concentration.length === 0 && formate !== Specifications.DRY)
          ? ''
          : ScaleGraphComponent(scale)}
      </>
    )
  }

  const VolumeComponent = () => {
    return (
      <div className={classes.componentSpacing}>
        <div className={classes.label}>
          <FormattedMessage {...messages.CONF_DNAPLATES_VOLUME_WELL} />
        </div>
        {sessionData[0].plateType === Specifications.MIXED ? (
          <div className={classes.helpText}>
            <FormattedMessage
              {...messages.CONF_DNAPLATE_VOLUME_MIXED_HELP_TEXT}
            />
          </div>
        ) : (
          ''
        )}
        <div className={classes.bottomMargin}>
          <Field
            name="volume"
            component={LiquidInputAdapter}
            value={amount}
            onChange={(e) => {
              handlerChange(e, Specifications.volume)
            }}
            filled
            className={classes.textInput}
          />
        </div>
        <div className={classes.helpText}>
          <FormattedMessage
            {...messages.CONF_DNAPLATES_VOLUME_RANGE}
            values={{ minVolume }}
          />
          {Number.isInteger(maxVolume) ? maxVolume : maxVolume.toFixed(1)}
          <FormattedMessage {...messages.CONF_DNAPLATES_VOLUME_MEASURE} />
        </div>

        <Grid className={reqAmount ? '' : classes.hideRow}>
          <div className={clsx(classes.colorRed, classes.errormsg)}>
            <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
          </div>
        </Grid>
        <div className={clsx(classes.errormsg)}>
          <ValidationErrors
            errors={
              validationVolumeErrors.length !== 0
                ? validationVolumeErrors
                : inValidVolume
            }
          />
        </div>
        <div>
          {amount &&
          amount.length !== 0 &&
          validationVolumeErrors.length === 0 &&
          inValidVolume.length === 0 &&
          validationConcentrationErrors.length === 0 &&
          inValidConcentration.length === 0
            ? state.specificationCalculationResponse.calculatedValues.scale !==
              null
              ? AmountGraphComponent(
                  state.specificationCalculationResponse.calculatedValues.scale
                )
              : ''
            : ''}
        </div>
        <div>{daughterPlatesComponent()}</div>
      </div>
    )
  }
  const AmountComponent = () => {
    return (
      <div className={classes.componentSpacing}>
        <div className={classes.label}>
          <FormattedMessage {...messages.CONF_DNAPLATES_AMOUNT_OLIGO} />
          {sessionData[0].plateType === Specifications.MIXED ? (
            <Tooltip
              title={
                <FormattedMessage {...messages.CONF_DNAPLATE_AMOUNT_HELPTEXT} />
              }
              placement="bottom-end"
              classes={{ tooltip: classes.InfoPopup, arrow: classes.arrow1 }}
              arrow
            >
              <InfoIcon
                aria-label="info"
                color="primary"
                className={classes.InfoIcon}
              ></InfoIcon>
            </Tooltip>
          ) : (
            ''
          )}
        </div>
        <div className={classes.bottomMargin}>
          <Field
            name="amount"
            component={LiquidInputAdapter}
            value={amount}
            onChange={(e) => {
              handlerChange(e, Specifications.amount)
            }}
            filled
            className={classes.textInput}
          />
        </div>
        <div className={classes.helpText}>
          <FormattedMessage {...messages.CONF_DNAPLATES_AMOUNT_RANGE} />
          {Number.isInteger(maxAmount) ? maxAmount : maxAmount.toFixed(1)}
          <FormattedMessage {...messages.CONF_DNAPLATES_AMOUNT_MOLES} />
        </div>
        <Grid className={reqAmount ? '' : classes.hideRow}>
          <div className={clsx(classes.colorRed, classes.errormsg)}>
            <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
          </div>
        </Grid>
        <div className={clsx(classes.errormsg)}>
          <ValidationErrors
            errors={
              validationAmountErrors.length !== 0
                ? validationAmountErrors
                : invalidAmount
            }
          />
        </div>
        <div>
          {amount &&
          amount.length !== 0 &&
          validationAmountErrors.length === 0 &&
          invalidAmount.length === 0 &&
          validationConcentrationErrors.length === 0 &&
          inValidConcentration.length === 0
            ? state.specificationCalculationResponse.calculatedValues.scale !==
              null
              ? AmountGraphComponent(
                  state.specificationCalculationResponse.calculatedValues.scale
                )
              : ''
            : ''}
        </div>
        <div>{daughterPlatesComponent()}</div>
      </div>
    )
  }

  const fixedVolumeComponent = () => {
    return (
      <>
        <Grid className={classes.componentSpacing}>
          <div className={classes.label}>
            <FormattedMessage
              {...messages.CONF_DNAPLATES_FIXED_VOLUME_PER_WELL}
            />
          </div>
          <div className={classes.leftSpace}>
            <RadioGroup
              aria-label="volPerWall"
              name="volPerWall"
              value={sessionData[0][Specifications.category]}
              className={classes.radioYesOrNo}
            >
              <FormControlLabel
                value="Yes"
                control={
                  <StyledRadio
                    isConfiguratorsRedesign="true"
                    className={classes.radio}
                    onChange={(e) => {
                      handlerChange(e, Specifications.normalization)
                    }}
                  />
                }
                label={
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_FIXED_WELL_YES}
                  />
                }
                className={classes.labelFont}
              />
              <FormControlLabel
                value="No"
                control={
                  <StyledRadio
                    isConfiguratorsRedesign="true"
                    className={classes.radio}
                    onChange={(e) => {
                      handlerChange(e, Specifications.normalization)
                    }}
                  />
                }
                label={
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_FIXED_WELL_NO}
                  />
                }
                className={classes.labelFont}
              />
            </RadioGroup>
            <ValidationErrors
              errors={
                validationFixedVolumeWellErrors[0] ===
                Specifications.RequiredField
                  ? [intl.formatMessage(messages.CONF_REQUIRED_FIELD)]
                  : []
              }
            />
            <Grid className={reqNormalization ? '' : classes.hideRow}>
              <div className={clsx(classes.colorRed, classes.errormsg)}>
                <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
              </div>
            </Grid>
          </div>
        </Grid>
        <Grid>
          {normalization === 'Yes' ? VolumeComponent() : ''}
          {normalization === 'No' ? ScaleComponent() : ''}
        </Grid>
      </>
    )
  }
  const wellNormalizationComponent = () => {
    return (
      <>
        <Grid className={classes.componentSpacing}>
          <div className={classes.label}>
            <FormattedMessage {...messages.CONF_DNAPLATES_WELL_NORMALIZATION} />
          </div>
          <div className={classes.leftSpace}>
            <RadioGroup
              aria-label="normalization"
              name="normalization"
              className={classes.radioButtons}
              value={sessionData[0][Specifications.category]}
            >
              <FormControlLabel
                value="Yes"
                control={
                  <StyledRadio
                    isConfiguratorsRedesign="true"
                    className={classes.radio}
                    onChange={(e) => {
                      handlerChange(e, Specifications.normalization)
                    }}
                  />
                }
                className={classes.labelFont}
                label={
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_WELL_NORMALIZATION_AMOUNT}
                  />
                }
              />
              <FormControlLabel
                value="No"
                control={
                  <StyledRadio
                    isConfiguratorsRedesign="true"
                    className={classes.radio}
                    onChange={(e) => {
                      handlerChange(e, Specifications.normalization)
                    }}
                  />
                }
                className={classes.labelFont}
                label={
                  <FormattedMessage {...messages._PC_SPEC_SYNTHESIS_SCALE} />
                }
              />
            </RadioGroup>
            <Grid className={reqNormalization ? '' : classes.hideRow}>
              <div className={clsx(classes.colorRed, classes.errormsg)}>
                <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
              </div>
            </Grid>
          </div>
        </Grid>
        {normalization === 'Yes' ? AmountComponent() : ''}
        {normalization === 'No' ? ScaleComponent() : ''}
      </>
    )
  }

  const concentrationComponent = () => {
    return (
      <>
        <Grid className={classes.componentSpacing}>
          <div className={classes.label}>
            <FormattedMessage {...messages.CONF_DNAPLATES_CONCENTRATION} />
          </div>
          {sessionData[0].plateType === Specifications.MIXED ? (
            <>
              <div className={classes.helpText}>
                <FormattedMessage
                  {...messages.CONF_DNAPLATE_CONCENTRATION_MIXED_HELP_TEXT_STEP1}
                />
              </div>
              <div className={classes.helpText}>
                <FormattedMessage
                  {...messages.CONF_DNAPLATE_CONCENTRATION_MIXED_HELP_TEXT_STEP2}
                />
              </div>
            </>
          ) : (
            ''
          )}
          {productDetails.countryCode === CountryCodes.JP ? (
            <div className={classes.leftSpace}>
              {populateSpecification(
                specificationsData,
                Specifications.concentration
              )}
            </div>
          ) : (
            <>
              <div className={classes.leftspaceCon}>
                <Field
                  name="contentration"
                  component={LiquidInputAdapter}
                  value={concentration}
                  onChange={(e) => {
                    handlerChange(e, Specifications.concentration)
                  }}
                  filled
                  className={classes.textInput}
                />
              </div>
              <div className={classes.helpText}>
                <FormattedMessage
                  {...messages.CONF_DNAPLATES_CONCENTRATION_RANGE}
                />
                {maxConcentration}
                <FormattedMessage
                  {...messages.CONF_DNAPLATES_CONCENTRATION_MEASURE}
                />
              </div>
            </>
          )}
          <Grid className={reqConcentration ? '' : classes.hideRow}>
            <div className={clsx(classes.colorRed, classes.errormsg)}>
              <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
            </div>
          </Grid>
          <div className={classes.errormsg}>
            <ValidationErrors
              errors={
                validationConcentrationErrors.length !== 0
                  ? validationConcentrationErrors
                  : inValidConcentration
              }
            />
          </div>
        </Grid>
        {sessionData[0].plateType === Specifications.MIXED
          ? VolumeComponent()
          : (productDetails.countryCode === CountryCodes.JP &&
                sessionData[0].plateType === Specifications.STANDARD &&
                sessionData[0].wellType === PlateProduct.wellType96) ||
              (productDetails.countryCode === CountryCodes.IN &&
                sessionData[0].plateType === Specifications.STANDARD)
            ? ScaleComponent()
            : sessionData[0].wellType === PlateProduct.wellType
              ? VolumeComponent()
              : fixedVolumeComponent()}
      </>
    )
  }

  const purificationcomoponent = () => {
    return (
      <>
        <Grid className={classes.componentSpacing}>
          <div className={classes.label}>
            <FormattedMessage {...messages.CONF_PURIFICATION} />
          </div>
          <div className={classes.leftSpace}>
            {populateSpecification(
              specificationsData,
              Specifications.purification
            )}
          </div>
          <Grid className={reqpurification ? '' : classes.hideRow}>
            <div className={clsx(classes.colorRed, classes.errormsg)}>
              <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
            </div>
          </Grid>
        </Grid>
        {purification === '' ||
        purification === null ||
        purification === undefined
          ? ''
          : formate !== 'DRY'
            ? concentrationComponent()
            : sessionData[0].plateType === Specifications.MIXED
              ? AmountComponent()
              : (productDetails.countryCode === CountryCodes.JP &&
                    sessionData[0].plateType === Specifications.STANDARD &&
                    sessionData[0].wellType === PlateProduct.wellType96) ||
                  (productDetails.countryCode === CountryCodes.IN &&
                    sessionData[0].plateType === Specifications.STANDARD)
                ? ScaleComponent()
                : sessionData[0].wellType === PlateProduct.wellType
                  ? AmountComponent()
                  : wellNormalizationComponent()}
      </>
    )
  }
  return (
    <div>
      <div className={classes.contentWrapper}>
        <Formik
          initialValues={{ oligoTubes: 1 }}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              actions.setSubmitting(false)
            }, 1000)
          }}
        >
          {() => (
            <>
              <Grid container>
                <Grid item xs={9} className={classes.specificationsHeading}>
                  <h2>
                    <FormattedMessage
                      {...messages.CONF_PEPSCREEN_SPECIFICATION}
                    />
                  </h2>
                </Grid>
                <Grid item xs={3}>
                  {productDetails.isCSRSupervisor === true ? (
                    <FormControlLabel
                      classes={{ label: classes.over1 }}
                      control={
                        <Checkbox
                          value={isOverriden}
                          color="primary"
                          checked={isOverriden}
                          onChange={() => {
                            handleOverride(!isOverriden)
                          }}
                          className={classes.overrideCheckBox}
                        />
                      }
                      label={messages.CONF_OVERRIDE_VALIDATION.defaultMessage}
                    />
                  ) : (
                    ''
                  )}
                </Grid>
              </Grid>
              <Grid
                className={clsx(
                  classes.specificationsHeading,
                  classes.specificationsHelpText
                )}
              >
                <FormattedMessage
                  {...messages.CONF_DNAPLATE_SPECIFICATIONS_HELP_TEXT}
                />
              </Grid>
              <Grid>
                <Grid className={classes.componentSpacing}>
                  <Grid container>
                    <Grid item className={classes.label}>
                      <FormattedMessage {...messages.CONF_FORMAT} />
                    </Grid>
                    <Grid item className={classes.helpIcon}>
                      <Tooltip
                        title={
                          <FormattedMessage
                            {...messages.CONF_FORMAT_INFO_standard}
                          />
                        }
                        placement="bottom-end"
                        classes={{
                          tooltip: classes.InfoPopup,
                          arrow: classes.arrow1,
                        }}
                        arrow
                      >
                        <InfoIcon
                          aria-label="info"
                          color="primary"
                          className={classes.InfoIcon}
                        ></InfoIcon>
                      </Tooltip>
                    </Grid>
                    <Grid item>
                      {productDetails.countryCode !== CountryCodes.JP && (
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_FORMATE_HELPTEXT}
                        />
                      )}
                    </Grid>
                  </Grid>
                  <div className={classes.leftSpace}>
                    {populateSpecification(
                      specificationsData,
                      Specifications.format
                    )}
                  </div>
                  <Grid className={reqFormate ? '' : classes.hideRow}>
                    <div className={clsx(classes.colorRed, classes.errormsg)}>
                      <FormattedMessage {...messages.CONF_REQUIRED_FIELD} />
                    </div>
                  </Grid>
                </Grid>
                {formate === '' || formate === null || formate === undefined
                  ? ''
                  : purificationcomoponent()}
              </Grid>
            </>
          )}
        </Formik>
      </div>
      <div>
        <Button
          color="primary"
          variant="contained"
          size="large"
          onClick={goToNextStep3}
          className={classes.confirmButton}
          id="plates-continue-button-2"
          data-testid="plates-continue-button-2"
        >
          <FormattedMessage {...messages.CONF_CONTINUE_DNA_PLATES} />
        </Button>
      </div>
      {(specificationLoading ||
        specificationValidationLoading ||
        totalValidationLoading) && <CircleLoader />}
    </div>
  )
}
export default DnaPlatesSpecifications
